import { useThemeColors } from '@/hooks/useThemeColors';
import { AmaSeries } from '@/types';
import { Link } from '@inertiajs/react';
import { ChevronRight, Video } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AmaSeriesListItemProps {
    amaSeries: AmaSeries;
    courseSlug: string;
}

const AmaSeriesListItem: React.FC<AmaSeriesListItemProps> = ({ amaSeries, courseSlug }) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    return (
        <Link
            href={`/courses/${courseSlug}/ama-series/${amaSeries.id}/`}
            className="group flex items-center justify-between rounded-lg px-4 py-3 transition-all duration-150 hover:bg-white dark:hover:bg-neutral-700"
        >
            <div className="flex items-center space-x-3">
                <Video size={16} className="text-purple-500" />
                <div>
                    <h4 className={`font-medium text-gray-900 dark:text-white group-hover:${colors.iconColor}`}>
                        {amaSeries.title}
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-neutral-400">
                        {amaSeries.record_count || 0} {t('course.sessions', 'sesiones')}
                    </p>
                </div>
            </div>
            <ChevronRight size={16} className={`text-gray-400 dark:text-neutral-500 transition-colors group-hover:${colors.iconColor}`} />
        </Link>
    );
};

export default AmaSeriesListItem;
